module["exports"] = [
  "Giant panda",
  "Spectacled bear",
  "Sun bear",
  "Sloth bear",
  "American black bear",
  "Asian black bear",
  "Brown bear",
  "Polar bear"
]


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/animal/bear.js
// module id = 2573
// module chunks = 1610